import { Utensils } from "lucide-react";
import { Stack, Typography } from "@mui/material";
import { Step } from "@/pages/checkout/hooks/useCheckoutSteps";
import { useOutletContext } from "react-router-dom";
import SummaryPanel from "@/pages/checkout/components/ConfirmationView/components/SummaryPanel";
import StepSummary from "@/pages/checkout/components/ConfirmationView/components/StepSummary";
import { useAppSelector } from "@/hooks";
import { RootState } from "@/store/store";
import { Content } from "@/types";
import useRoutes from "@/hooks/useRoutes";

const ConfirmationView = () => {
    const [navigate] = useRoutes();
    const { steps } = useOutletContext<{ steps: Step[] }>();
    const order = useAppSelector((state: RootState) => state.order);

    const getDetails = (item: Content) => {
        const details = Object.values(item?.settings ?? {})
            .map((s) => {
                return s?.options?.title;
            })
            .join(' ');

        return details;
    };
    
    return (
        <Stack spacing={3}>
            <SummaryPanel
                title="¿Qué recibirás?"
                icon={<Utensils/>}
                onEdit={() => navigate('organizations.menu.main')}
            >
                {order?.items?.map((item: any) => (
                    <Stack key={item.id} spacing={2} direction={'row'}>
                        <Stack flex={1}>
                            <Typography fontWeight={600}>
                                {item.quantity} - {item.title}
                            </Typography>
                            <Typography variant="body1">{getDetails(item)}</Typography>
                            {item?.comments ? (
                                <Typography variant="body1">
                                    Comentarios: {item?.comments}
                                </Typography>
                            ) : null}
                        </Stack>
                    </Stack>
                ))}
            </SummaryPanel>
            
            {steps.map((step) => (
                <StepSummary step={step} />
            ))}
        </Stack>
    )
}

export default ConfirmationView;
